export default __webpack_public_path__ + "static/media/vetolib.66b3f6b9.png";